import { brl } from "@/lib/format";
import { MONTHS } from "@/lib/dre";

export function DreYear({ d }) {
  const total = (k) => d.months.reduce((a, m) => a + m.values[k], 0);
  return (
    <div className="card overflow-x-auto" style={{ padding: 0 }} data-testid="dre-year-table">
      <table className="text-xs min-w-[1200px] w-full">
        <thead>
          <tr className="caption uppercase" style={{ background: "var(--surface-alt)" }}>
            <th className="px-3 py-3 text-left sticky left-0" style={{ background: "var(--surface-alt)" }}>Linha</th>
            {d.months.map((m) => <th key={m.month} className="px-2 py-3 text-right" style={{ opacity: m.future ? 0.45 : 1 }}>{MONTHS[Number(m.month.slice(5)) - 1].slice(0, 3)}</th>)}
            <th className="px-3 py-3 text-right">Total</th>
          </tr>
        </thead>
        <tbody>
          {d.lines.map((l) => (
            <tr key={l.key} className={`border-t ${l.kind === "item" ? "caption" : "font-semibold"}`} style={{ borderColor: "var(--border)", background: l.kind === "result" ? "var(--brand-soft)" : undefined }} data-testid={`dre-year-line-${l.key}`}>
              <td className={`py-2 sticky left-0 whitespace-nowrap ${l.kind === "item" ? "pl-6 pr-3" : "px-3"}`} style={{ background: l.kind === "result" ? "var(--brand-soft)" : "var(--surface)" }}>{l.label}</td>
              {d.months.map((m) => <td key={m.month} className="px-2 py-2 text-right tnum whitespace-nowrap" style={{ opacity: m.future ? 0.45 : 1, color: m.values[l.key] < 0 ? "var(--danger)" : undefined }}>{m.future ? "—" : brl(m.values[l.key]).replace("R$ ", "")}</td>)}
              <td className="px-3 py-2 text-right tnum whitespace-nowrap" style={{ color: total(l.key) < 0 ? "var(--danger)" : undefined }}>{brl(total(l.key)).replace("R$ ", "")}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
